import { userService } from "@/lib/services/userService";
import { BranchType, DoctorOverview } from "@/types";
import { Flex, FormControl, FormErrorMessage, FormLabel, Input, Select, Switch, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface AppointmentInformationProps {
  register: any;
  errors: any;
  setValue: any;
  editingUser?: DoctorOverview | null;
}

const AppointmentInformation: React.FC<AppointmentInformationProps> = ({ register, errors, setValue, editingUser = null }) => {
  const [branch, setBranch] = useState<BranchType[]>([]);

  useEffect(() => {
    const fetchDesignations = async () => {
      const data = await userService.getBranch();
      setBranch(data);
    };

    fetchDesignations();
  }, []);

  useEffect(() => {
    if (editingUser && branch.length > 0) {
      setValue('appointment_type', editingUser.appointment?.type || '');
      setValue('branch_id', editingUser.branch?.id?.toString());
      setValue('advance_booking_days', editingUser.appointment?.advance_booking || 0);
      setValue('appointment_duration', editingUser.appointment?.appointment_duration || 0);
      setValue('appointment_slot_duration', editingUser.appointment?.slot_duration || 0);
      setValue('consultation_fee', editingUser.appointment?.consultation_fee || 0);
      setValue('display_on_booking_page', editingUser.status === 1);
    }
  }, [editingUser, setValue, branch]);

  return (
    <>
      <Flex gap={2}>
        <FormControl isInvalid={!!errors.appointment_type}>
          <FormLabel fontWeight="medium">Appointment Type</FormLabel>
          <Select placeholder="Select" {...register("appointment_type")}>
            <option value="face_to_face">Face to Face</option>
            <option value="online">Online</option>
            <option value="home_visit">Home Visit</option>
          </Select>
          <FormErrorMessage>{errors.appointment_type?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.branch_id}>
          <FormLabel fontWeight="medium">
            Branch{" "}
            <Text as="span" color="red.500">
              *
            </Text>
          </FormLabel>
          <Select {...register("branch_id")}>
            <option value="">
              Select
            </option>
            {branch.map((br: BranchType) => (
              <option key={br.id} value={br.id}>
                {br.name}
              </option>
            ))}
          </Select>
          <FormErrorMessage>{errors.branch_id?.message}</FormErrorMessage>
        </FormControl>
      </Flex>

      <Flex gap={2} mt={3}>
        <FormControl isInvalid={!!errors.advance_booking_days}>
          <FormLabel fontWeight="medium">Accept bookings (in advance)</FormLabel>
          <Flex gap={2} align="center">
            <Input
              type="number"
              {...register("advance_booking_days", {
                valueAsNumber: true,
              })}
            />
            <Text fontSize="sm">Days</Text>
          </Flex>
          <FormErrorMessage>{errors.advance_booking_days?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.appointment_duration}>
          <FormLabel fontWeight="medium">Appointment Duration</FormLabel>
          <Flex gap={2} align="center">
            <Input
              type="number"
              {...register("appointment_duration", {
                valueAsNumber: true,
              })}
            />
            <Text fontSize="sm">Mins</Text>
          </Flex>
          <FormErrorMessage>{errors.appointment_duration?.message}</FormErrorMessage>
        </FormControl>
      </Flex>

      <Flex gap={2} mt={3}>
        <FormControl isInvalid={!!errors.appointment_slot_duration}>
          <FormLabel fontWeight="medium">Max Bookings Per Slot</FormLabel>
          <Input
            type="number"
            {...register("appointment_slot_duration", {
              valueAsNumber: true,
            })}
          />
          <FormErrorMessage>{errors.appointment_slot_duration?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.consultation_fee}>
          <FormLabel fontWeight="medium">Consultation Charge</FormLabel>
          <Input
            type="number"
            {...register("consultation_fee", {
              valueAsNumber: true,
            })}
          />
          <FormErrorMessage>{errors.consultation_fee?.message}</FormErrorMessage>
        </FormControl>
      </Flex>

      {/* <FormControl mt={2}>
        <Flex align="center" gap={2}>
          <Text fontSize="sm">
            Display on Booking Page <Switch {...register("display_on_booking_page")} />
          </Text>
        </Flex>
      </FormControl> */}
    </>
  );
};

export default AppointmentInformation;